import type { ChatStatusCountsResponse } from "@/features/chat/domain/repositories/chat";

// Total of chats in mocks chats
export const mockStatusCounts: ChatStatusCountsResponse = {
  unread: 4,
  muted: 1,
  blocked: 1,
  to_deliver: 2,
  pending_requests: 2
};
